import React from "react";
import { Grid } from "@material-ui/core";
import ImgHeader from "../ImgHeader";
import ScrollToTopOnMount from "../ScrollToTopOnMount";
import { H1, H2 } from "../Headers";
import SubmitTicketsCard from "../cards/SubmitTicketsCard";
import ViewTicketsCard from "../cards/ViewTicketsCard";
import WithHelperBar from "../WithHelperBar";
import SubmitServiceRequestCard from "../cards/SubmitServiceRequestCard";
import SMSCredentialsCard from "../cards/SMSCredentialsCard";

export default () => {
  return (
    <>
      <ScrollToTopOnMount />

      <ImgHeader url="/static/img/support_v.2.png" shadowOpacity={0.5}>
        <H1>
          Let's figure this
          <br /> out, together.
        </H1>
      </ImgHeader>
      <WithHelperBar>
        <H2>Support Tickets</H2>
        <Grid container spacing={3}>
          <SubmitTicketsCard />
          <SubmitServiceRequestCard />
          <ViewTicketsCard />
          <SMSCredentialsCard />
        </Grid>
      </WithHelperBar>
    </>
  );
};
